var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconReportProblemLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .problemline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .st0 {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "problemline",
    d: "M22.19,7.38L4.56,39.53c-1.17,2.13.37,4.73,2.8,4.73h35.25c2.43,0,3.97-2.6,2.8-4.73L27.8,7.38c-1.21-2.21-4.39-2.21-5.61,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "problemline",
    cx: 24.99,
    cy: 37.35,
    r: 0.82
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.99,18.38l-1.01,12.37c-.09,1.2-1.9,1.2-1.99,0,0,0-1.01-12.37-1.01-12.37-.13-2.85,4.13-2.86,4,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconReportProblemLine);
export default __webpack_public_path__ + "static/media/cloud_icon_report_problem_line.1446e102a4ccbd3abab77b4efc4fb9a6.svg";
export { ForwardRef as ReactComponent };